<template>
  <div class="tag-field-picker">
    <div class="field-content" v-show="step === 0" v-loading="popoverLoading">
      <div class="field-picker-header">
        <div class="field-picker-title">
          <span>请选择关键标签</span>
          <el-button type="primary" size="mini" @click="createFieldHandle">
            <span>创建新标签</span>
          </el-button>
        </div>
        <select-text v-if="selectText" :text="selectText" />
      </div>
      <div class="field-picker-ul" v-if="pickRuleModal.fields.length > 0">
        <div
          class="field-item"
          v-for="fieldDetail in pickRuleModal.fields"
          :key="fieldDetail.field_name"
          @click="pickFieldHandle(fieldDetail)"
        >
          <span>{{ fieldDetail.title }}</span>
        </div>
      </div>
    </div>

    <dict-picker
      v-if="isDictField && step !== 0"
      v-show="step === 1"
      :fieldDetail="currentField"
      :recommendWord="pickRuleModal.eventInfo.selectionStr"
      :popoverLoading="popoverLoading"
      @closePopover="$emit('close')"
      @prevStep="step = 0"
      @next="pickDictHandle"
    >
      <select-text v-if="selectText" :text="selectText" slot="header-tips" />
    </dict-picker>

    <entities-picker
      v-if="isDictField ? step === 2 : step === 1"
      :popoverLoading="popoverLoading"
      :caseDetail="pickRuleModal.caseDetail"
      :currentField="currentField"
      @closePopover="$emit('close')"
      @prevStep="() => (isDictField ? (step = 1) : (step = 0))"
      @next="emitConfirm"
    >
      <select-text v-if="selectText" :text="selectText" slot="header-tips" />
    </entities-picker>
  </div>
</template>

<script>
import dictPicker from './tagFieldPickerComponents/dictPicker';
import entitiesPicker from './tagFieldPickerComponents/entitiesPicker';

export default {
  components: {
    dictPicker,
    entitiesPicker,
    selectText: {
      props: {
        text: {
          type: String,
          default: ''
        }
      },
      render: function(h) {
        return h(
          'el-tooltip',
          { props: { content: this.text, placement: 'top', effect: 'light', 'popper-class': 'tag-popover-tooltip' } },
          [h('div', { class: 'select-text single-ellipsis', domProps: { innerHTML: `标签划词：${this.text}` } })]
        );
      }
    }
  },
  data() {
    return {
      step: 0,
      currentField: null,
      dictVal: ''
    };
  },
  props: {
    pickRuleModal: {
      type: Object,
      required: true
    },
    popoverLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDictField() {
      if (!this.currentField) {
        return false;
      }
      return this.currentField.type === 'text' && this.currentField.deputy_type === 'dict';
    },
    selectText() {
      return this.pickRuleModal.eventInfo.selectionStr;
    }
  },
  created() {
    if (this.pickRuleModal.defaultFieldDetail) {
      this.pickFieldHandle(this.pickRuleModal.defaultFieldDetail);
    }
  },
  methods: {
    createFieldHandle() {
      this.$emit('close');
      this.$emit('createField', {
        selectText: this.selectText,
        paragraphKey: this.pickRuleModal.eventInfo.focusParagraphKey
      });
      window.getSelection().removeAllRanges();
    },
    pickFieldHandle(fieldDetail) {
      this.currentField = fieldDetail;
      if (this.isDictField) {
        this.step = 1;
      } else if (fieldDetail.groupRelationId !== 'case') {
        this.step = 1;
      } else {
        this.emitConfirm();
      }
    },
    pickDictHandle(val) {
      this.dictVal = val;
      if (this.currentField.groupRelationId !== 'case') {
        this.step = 2;
      } else {
        this.emitConfirm();
      }
    },
    emitConfirm(relationParams = {}) {
      this.$emit('confirm', {
        ...this.pickRuleModal,
        rule: this.currentField,
        dictVal: this.dictVal,
        isEmptyOffset: this.pickRuleModal.isEmptyOffset,
        relationParams
      });
    }
  }
};
</script>
<style lang="scss">
.tag-popover-tooltip {
  max-width: 300px;
  word-break: break-all;
  line-height: 20px;
}
</style>
<style lang="scss" scoped>
.select-text {
  display: inline-block;
  max-width: 100%;
  color: rgba(#77839e, 0.7);
  font-size: 12px;
  line-height: 17px;
  font-weight: 300;
}
.tag-field-picker {
  .field-content {
    box-sizing: border-box;
    padding: 12px 0 6px;

    .field-picker-header {
      font-size: 14px;
      color: #3d465a;
      border-bottom: 1px solid #e8ebef;
      padding: 0 12px 0px;
      margin-bottom: 5px;

      &:last-child {
        border-bottom: 0;
      }

      .field-picker-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 24px;
        margin-bottom: 2px;
      }
    }

    .field-picker-ul {
      max-height: 258px;
      overflow-y: auto;
      overflow-x: hidden;

      .field-item {
        font-size: 14px;
        line-height: 20px;
        word-break: break-all;
        padding: 5px 15px;
        cursor: pointer;

        &:hover {
          background-color: #eaf6ff;
        }
      }
    }
  }
}
</style>
